<script lang="ts">
	import {
		TableBody,
		TableBodyCell,
		TableBodyRow,
		TableHead,
		TableHeadCell,
		TableSearch,
		A,
		Heading
	} from 'flowbite-svelte';
	import { formatCurrency } from '$lib/formatting';
	import { writable } from 'svelte/store';

	export let slug = '';
	export let items = [];
	let search = '';

	const sortKey = writable('expected_value'); // default sort key
	const sortDirection = writable(-1); // default sort direction (ascending)
	const sortItems = writable([...items]); // make a copy of the items array

	// Define a function to sort the items
	const sortTable = (key: string) => {
		// If the same key is clicked, reverse the sort direction
		if ($sortKey === key) {
			sortDirection.update((val) => -val);
		} else {
			sortKey.set(key);
			sortDirection.set(1);
		}
	};

	$: {
		const key = $sortKey;
		const direction = $sortDirection;
		const s = search;
		const sortedAndFiltered = items
			.filter((item) => {
				if (!s) return true;
				return item.name.toLowerCase().includes(s.toLowerCase());
			})
			.sort((a, b) => {
				const aVal = a[key];
				const bVal = b[key];
				if (aVal < bVal) {
					return -direction;
				} else if (aVal > bVal) {
					return direction;
				}
				return 0;
			});
		sortItems.set(sortedAndFiltered);
	}
</script>

{#if items.length === 0}
	<Heading tag="h2" class="text-center">Coming soon!</Heading>
{:else}
	<div class="table w-full sm:text-lg">
		<TableSearch placeholder="Search for a game..." bind:inputValue={search} hoverable={true}>
			<TableHead>
				<TableHeadCell on:click={() => sortTable('name')}>Name</TableHeadCell>
				<TableHeadCell on:click={() => sortTable('expected_value')}>Score</TableHeadCell>
				<TableHeadCell on:click={() => sortTable('price')}>Price</TableHeadCell>
			</TableHead>
			<TableBody tableBodyClass="divide-y">
				{#each $sortItems as item}
					<TableBodyRow>
						<TableBodyCell
							><A href={`/state/${slug}/game/${item.id}`}>{item.name} #{item.game_id}</A
							></TableBodyCell
						>
						<TableBodyCell>🏆{Math.round(item.expected_value * 100)}</TableBodyCell>
						<TableBodyCell>{formatCurrency(item.price)}</TableBodyCell>
					</TableBodyRow>
				{/each}
			</TableBody>
		</TableSearch>
	</div>
{/if}

<style lang="postcss">
	@media only screen and (max-width: 500px) {
		.table {
			& table,
			& thead,
			& tbody,
			& th,
			& td,
			& tr {
				display: block;
			}
			& thead tr {
				position: absolute;
				top: -9999px;
				left: -9999px;
			}
			& tr {
				border: 2px solid #ccc;
				overflow: hidden;
			}
			& td {
				/* Behave  like a "row" */
				border: none;
				border-bottom: 1px solid #eee;
				position: relative;
				padding-left: 50%;
			}
			& td:before {
				/* Now like a table header */
				position: absolute;
				/* Top/left values mimic padding */
				top: 6px;
				left: 6px;
				width: 45%;
				padding-right: 10px;
				white-space: nowrap;
			}
			& td:nth-of-type(1):before {
				content: 'Name';
			}
			& td:nth-of-type(2):before {
				content: 'Score';
			}
			& td:nth-of-type(3):before {
				content: 'Price';
			}
		}
	}
</style>
